import React, { memo } from 'react';
import PropTypes from 'prop-types';
import EmbedBlock from './embed';

function TiktokBlock({ html }) {
  const condition = 'undefined' !== typeof window.tiktokEmbed;
  const callback = () => {
    window.tiktokEmbed.isEventsInit();
  };

  return (
    <EmbedBlock
      html={html}
      condition={condition}
      callback={callback}
    />
  );
}

TiktokBlock.propTypes = {
  html: PropTypes.string,
};

TiktokBlock.defaultProps = {
  html: '',
};

export default memo(TiktokBlock);
